"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSShiftSection = void 0;
const ui_1 = require("@app/component/ui");
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const use_calendar_settings_1 = require("@app/util/use-calendar-settings");
const react_1 = __importDefault(require("react"));
const calendar_settings_context_1 = require("../../../calendar-settings-context");
const process_options_1 = require("../../../util/process-options");
const _shiftShowTimeDataAsOptions = [
    {
        value: use_calendar_settings_1.ShiftShowTimeDataAs.Period,
        label: 'START_AND_END',
    },
    {
        value: use_calendar_settings_1.ShiftShowTimeDataAs.Duration,
        label: 'CUSTOM_ATTRIBUTE_TYPE.duration',
    },
];
const _shiftShowAtBottomOptions = [
    {
        value: use_calendar_settings_1.ShiftShowAtBottom.Position,
        label: 'POSITION',
    },
    {
        value: use_calendar_settings_1.ShiftShowAtBottom.Duration,
        label: 'CUSTOM_ATTRIBUTE_TYPE.duration',
    },
    {
        value: use_calendar_settings_1.ShiftShowAtBottom.Locality,
        label: 'LOCALITY',
    },
    {
        value: use_calendar_settings_1.ShiftShowAtBottom.Nothing,
        label: 'NOTHING',
    },
];
const _shiftColorBasedOnOptions = [
    {
        value: use_calendar_settings_1.ShiftColorBasedOn.Position,
        label: 'POSITION',
    },
    {
        value: use_calendar_settings_1.ShiftColorBasedOn.RON,
        label: 'RON',
    },
];
const CSShiftSection = () => {
    const shiftShowTimeDataAsOptions = react_1.default.useRef((0, process_options_1.processOptions)(_shiftShowTimeDataAsOptions));
    const shiftShowAtBottomOptions = react_1.default.useRef((0, process_options_1.processOptions)(_shiftShowAtBottomOptions));
    const shiftColorBasedOnOptions = react_1.default.useRef((0, process_options_1.processOptions)(_shiftColorBasedOnOptions));
    const { control } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    return (react_1.default.createElement("div", { style: { padding: '0.75rem' } },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    paddingBottom: '0.5rem',
                    boxSizing: 'border-box',
                } },
                react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('CALENDAR_SETTINGS_SHIFT_SECTION_TITLE')),
                react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_4, type: ui_1.Spacing.TYPES.HORIZONTAL }),
                react_1.default.createElement(dropdown_input_1.DropdownInput, { label: (0, util_1.t)('SHOW_TIME_DATA_AS'), control: control, name: 'shiftShowTimeDataAs', options: shiftShowTimeDataAsOptions.current, sortedOptions: false }),
                react_1.default.createElement(dropdown_input_1.DropdownInput, { label: (0, util_1.t)('SHOW_AT_BOTTOM'), control: control, name: 'shiftShowAtBottom', options: shiftShowAtBottomOptions.current, sortedOptions: false }),
                react_1.default.createElement(dropdown_input_1.DropdownInput, { label: (0, util_1.t)('SHIFT_COLOR_BASED_ON'), control: control, name: 'shiftColorBasedOn', options: shiftColorBasedOnOptions.current, sortedOptions: false })))));
};
exports.CSShiftSection = CSShiftSection;
